import { render, staticRenderFns } from "./DeathInfo.vue?vue&type=template&id=8905b8c6&scoped=true"
import script from "./DeathInfo.vue?vue&type=script&lang=js"
export * from "./DeathInfo.vue?vue&type=script&lang=js"
import style0 from "./DeathInfo.vue?vue&type=style&index=0&id=8905b8c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8905b8c6",
  null
  
)

export default component.exports